import React, { FunctionComponent, JSX } from "react";
import styles from "./Menu.module.scss";

import { HamburgerComponent } from "./hamburger/Hamburger.component";
import { useMenu } from "./useMenu";
import {
  MenuItemComponent,
} from "./menu-item/MenuItem.component";
import { mainMenu, MenuItem } from "./MainMenu";

export const MenuComponent: FunctionComponent = (): JSX.Element => {
  const { isHamburgerOpen } = useMenu();

  // const { library } = useWeb3React<providers.Web3Provider>();

  return (
    <>
      <ul
        className={[
          styles["menu"], isHamburgerOpen ? styles["visible"] : "",
        ].join(" ")}>
        { mainMenu
          .map((item: MenuItem) => {
            return (
              <MenuItemComponent
                key={item.index}
                title={item.title}
                icon={item.icon}
                disabled={item.disabled}
                tabKey={item.tabKey}
              />
            );
          })
        }
      </ul>

      {/* <ConnectButtonComponent /> */}

      <HamburgerComponent/>
    </>
  );
};
